var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchYear',{attrs:{"title":'Contas da Festa',"minYear":1979,"directory":'contas_festa'}})}
var staticRenderFns = []

export { render, staticRenderFns }